let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("d5VI3")).then(() => parcelRequire('aQeCP'));